var registerbooking = {
    text1:"POINTS EARNED:",
    pending:"PENDING",
    available:"AVAILABLE TO REDEEM",
    text2:"Register Your Booking to Earn Cash",
    bookingSource: "Booked Via",
    bookingNumber: "Booking Number",
    clientName: "Client Name",
    resort: "Resort",
    select: "Select",
    date: "Arrival Date",
    date1: "Departure Date",
    room: "Room Category",
    roomTotal: "Total of Nights",
    menuTour:"Menu Tour",
    enteredBy:"How did you hear of us:",
    sendbtn: "Send",
    sentbtn: "Sent",
    packagetotalcost:"Total cost of package",
    addrow: "Add another row +",
    addrowShort: "Add another booking",
    media: "RESORTS MEDIA GALERY",
    offers: "OFFERS",
    error: "Select a Booking Source",
    error2: "Enter Booking Number",
    error3: "Enter Client Name",
    error4: "Select a Resort",
    invalidDate: "Invalid Date",
    holderbooking:"Enter Source",
    holderNumber:"Enter Number",
    holderName:"Enter FullName",
    residence:"Residence",
    suite:"Suite",
    bedRoom:"1 BedRoom",
    other:"Other",
    holderRoom:"Enter Total",
    holderTour:"Enter Tour",
    holderEntered:"Enter Source",
    notApply:"Note: *Incentive does not apply to bookings made from Canada",
    isgroup:"Is Group?",
    groupyes:"Yes",
    groupno: "No",
    groupNumber:"Quantity of Bookings",
    holderNumber1:"Enter Number",
    notApplyGroups:"Does not apply to groups.",
    isThisAGroup:"Is this a contracted Group?",
    lessrow:"Remove last row -",
    lessrowShort:"Remove last booking",
    bookingLabel:"Booking #",
    various:"Various",
    sendingMessage:"Please wait a moment, we are sending your request",
    successRowMessage:"The booking was sent successfully.",
    noteText10:"A minimum stay of 3 nights is required to generate Points. Points apply for stays of up to 6 nights; stays of 7 nights or more, generate double Points. Applies for reservations entered through any channel and through your favorite tour operator."
}
module.exports = registerbooking
